import { Controller } from "@hotwired/stimulus"

// 個票名を編集する <dialog> モーダル。 「✎ 名前を編集」 ボタンの click で開く。
// ?edit=1 クエリ付きで遷移してきた場合は connect 時に自動で開く ( 一覧から「編集」 で来た場合 )。
export default class extends Controller {
  static targets = ["dialog", "input"]

  connect() {
    const params = new URLSearchParams(window.location.search)
    if (params.get("edit") === "1") {
      requestAnimationFrame(() => this.showDialog())
    }
  }

  open(event) {
    if (event) event.preventDefault()
    this.showDialog()
  }

  showDialog() {
    if (this.dialogTarget.open) this.dialogTarget.close()
    this.dialogTarget.showModal()
    requestAnimationFrame(() => {
      this.inputTarget.focus()
      this.inputTarget.select()
    })
  }

  cancel(event) {
    event.preventDefault()
    this.dialogTarget.close()
  }
}
